import script from "./StockWeb.vue?vue&type=script&setup=true&lang=js"
export * from "./StockWeb.vue?vue&type=script&setup=true&lang=js"

import "./StockWeb.vue?vue&type=style&index=0&id=6706b941&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6706b941"]])

export default __exports__